const QueryDuplicateProfileMutation = `
  mutation (
    $id: String!
  ) {
    profileDuplicate(
      input: {
        id: $id,
      }
    ) {
      profile {
        id
        title
        templateNumber
        profileStrength
        createdAt
        updatedAt
      }
    }
  }
`

export default QueryDuplicateProfileMutation
